module.exports = __webpack_public_path__ + "static/media/John P. Hale - 1852.568c75de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/John P. Hale - 1852.jpg
// module id = 522
// module chunks = 0